export const SIZE = {
  SM: '300px',
  MD: '500px',
  LG: '700px',
  FULL: '1200px',
  DEFAULT: '500px',
}

export const POPUP_OPEN_CLASS = 'pam-attention-popup-open'
